const common = {
  "members.label.member": "Member",
  "members.label.members": "Members",
};

const membersPage = {
  "members.table.header.member": "Member",
  "members.table.header.byb-iq": "BYB IQ",
  "members.table.see-progress": "See Progress",
  "members.table.no-data": "No member data available",
  "members.table.manage-columns": "Manage columns",
  "members.download-report": "Download Report",
  "members.invite.remaining-seats": "{{ count }} remaining",
  "members.filters.search": "Search members...",
  "members.filters.status": "Status",
  "members.filters.role": "Role",
  "members.filters.roles": "Roles",
  "members.filters.all": "All",
  "members.filters.all-roles": "All roles",
  "members.filters.results": "{{ count }} results",
  "members.filters.default-sort": "Default Sort",
  "members.filters.sort-name": "Name",
  "members.filters.sort-role": "Role",
  "members.filters.default-filter": "Default Filter",
  "members.filters.filtered": "Filtered",
  "members.filters.clear-filters": "Clear filters",

  "members.member.delete-confirmation.title": "Remove Member",
  "members.member.delete-confirmation.message": "Are you sure you want to remove this member?",
  "members.pending.delete-confirmation.title": "Delete Invite",
  "members.pending.delete-confirmation.message": "Are you sure you want to delete this invite?",
};

const memberProfile = {
  "members.profile.delete-member": "Delete Member",
};

export const members = {
  ...common,
  ...membersPage,
  ...memberProfile,
};
